
<div class="breadcrumbs">
  <div class="breadcrumbs__container">
    <ul class="breadcrumbs__links">
      <li class="breadcrumbs__linkItem">
        <a href="/" class="breadcrumbs__linkText">グルメプラスTOP</a>
      </li>
      <template v-if="station">
        <template v-if="(pageType || shopType) && yenOrPeople && count">
          <li class="breadcrumbs__linkItem">
            <a href="../../../../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ prefecture }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="../../../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ area }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="../../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ areaDetail }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ station }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ station }}x{{ typeLabel }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <span class="breadcrumbs__linkText breadcrumbs__linkText--current">{{ station }}の{{ typeLabel }}で{{ yenOrPeopleLabel }}の宴会・パーティが可能なお店をご紹介</span>
          </li>
        </template>
        <template v-else-if="peopleCount && yenCount">
          <li class="breadcrumbs__linkItem">
            <a href="../../../../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ prefecture }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="../../../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ area }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="../../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ areaDetail }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ station }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ station }}x{{ peopleCount }}人</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <span class="breadcrumbs__linkText breadcrumbs__linkText--current">{{ station }}で{{ peopleCount }}人以上の予算{{ yenCount }}円以下の宴会・パーティが可能なお店をご紹介</span>
          </li>
        </template>
        <template v-else-if="(pageType || shopType)">
          <li class="breadcrumbs__linkItem">
            <a href="../../../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ prefecture }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="../../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ area }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ areaDetail }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ station }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <span class="breadcrumbs__linkText breadcrumbs__linkText--current">{{ station }}x{{ typeLabel }}</span>
          </li>
        </template>
        <template v-else-if="yenOrPeople && count">
          <li class="breadcrumbs__linkItem">
            <a href="../../../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ prefecture }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="../../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ area }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ areaDetail }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ station }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <span class="breadcrumbs__linkText breadcrumbs__linkText--current">{{ station }}で{{ yenOrPeopleLabel }}の宴会・パーティが可能なお店をご紹介</span>
          </li>
        </template>
        <template v-else>
          <li class="breadcrumbs__linkItem">
            <a href="../../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ prefecture }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ area }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ areaDetail }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <span class="breadcrumbs__linkText breadcrumbs__linkText--current">{{ station }}</span>
          </li>
        </template>
      </template>
      <template v-else-if="areaDetail">
        <template v-if="(pageType || shopType) && yenOrPeople && count">
          <li class="breadcrumbs__linkItem">
            <a href="../../../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ prefecture }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="../../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ area }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ areaDetail }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ areaDetail }}x{{ typeLabel }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <span class="breadcrumbs__linkText breadcrumbs__linkText--current">{{ areaDetail }}の{{ typeLabel }}で{{ yenOrPeopleLabel }}の宴会・パーティが可能なお店をご紹介</span>
          </li>
        </template>
        <template v-else-if="peopleCount && yenCount">
          <li class="breadcrumbs__linkItem">
            <a href="../../../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ prefecture }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="../../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ area }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ areaDetail }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ areaDetail }}x{{ peopleCount }}人</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <span class="breadcrumbs__linkText breadcrumbs__linkText--current">{{ areaDetail }}で{{ peopleCount }}人以上の予算{{ yenCount }}円以下の宴会・パーティが可能なお店をご紹介</span>
          </li>
        </template>
        <template v-else-if="(pageType || shopType)">
          <li class="breadcrumbs__linkItem">
            <a href="../../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ prefecture }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ area }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ areaDetail }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <span class="breadcrumbs__linkText breadcrumbs__linkText--current">{{ areaDetail }}x{{ typeLabel }}</span>
          </li>
        </template>
        <template v-else-if="yenOrPeople && count">
          <li class="breadcrumbs__linkItem">
            <a href="../../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ prefecture }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ area }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ areaDetail }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <span class="breadcrumbs__linkText breadcrumbs__linkText--current">{{ areaDetail }}で{{ yenOrPeopleLabel }}の宴会・パーティが可能なお店をご紹介</span>
          </li>
        </template>
        <template v-else>
          <li class="breadcrumbs__linkItem">
            <a href="../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ prefecture }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ area }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <span class="breadcrumbs__linkText breadcrumbs__linkText--current">{{ areaDetail }}</span>
          </li>
        </template>
      </template>
      <template v-else-if="area">
        <template v-if="(pageType || shopType) && yenOrPeople && count">
          <li class="breadcrumbs__linkItem">
            <a href="../../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ prefecture }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ area }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ area }}x{{ typeLabel }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <span class="breadcrumbs__linkText breadcrumbs__linkText--current">{{ area }}の{{ typeLabel }}で{{ yenOrPeopleLabel }}の宴会・パーティが可能なお店をご紹介</span>
          </li>
        </template>
        <template v-else-if="peopleCount && yenCount">
          <li class="breadcrumbs__linkItem">
            <a href="../../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ prefecture }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ area }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ area }}x{{ peopleCount }}人</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <span class="breadcrumbs__linkText breadcrumbs__linkText--current">{{ area }}で{{ peopleCount }}人以上の予算{{ yenCount }}円以下の宴会・パーティが可能なお店をご紹介</span>
          </li>
        </template>
        <template v-else-if="(pageType || shopType)">
          <li class="breadcrumbs__linkItem">
            <a href="../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ prefecture }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ area }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <span class="breadcrumbs__linkText breadcrumbs__linkText--current">{{ area }}x{{ typeLabel }}</span>
          </li>
        </template>
        <template v-else-if="yenOrPeople && count">
          <li class="breadcrumbs__linkItem">
            <a href="../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ prefecture }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ area }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <span class="breadcrumbs__linkText breadcrumbs__linkText--current">{{ area }}で{{ yenOrPeopleLabel }}の宴会・パーティが可能なお店をご紹介</span>
          </li>
        </template>
        <template v-else>
        <li class="breadcrumbs__linkItem">
          <a href="..">
            <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ prefecture }}</span>
          </a>
        </li>
        <li class="breadcrumbs__linkItem">
          <span class="breadcrumbs__linkText breadcrumbs__linkText--current">{{ area }}</span>
        </li>
      </template>
      </template>
      <template v-else>
        <template v-if="(pageType || shopType) && yenOrPeople && count">
          <li class="breadcrumbs__linkItem">
            <a href="../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ prefecture }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ prefecture }}x{{ typeLabel }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <span class="breadcrumbs__linkText breadcrumbs__linkText--current">{{ prefecture }}の{{ typeLabel }}で{{ yenOrPeopleLabel }}の宴会・パーティが可能なお店をご紹介</span>
          </li>
        </template>
        <template v-else-if="peopleCount && yenCount">
          <li class="breadcrumbs__linkItem">
            <a href="../..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ prefecture }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <a href="..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ prefecture }}x{{ peopleCount }}人</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <span class="breadcrumbs__linkText breadcrumbs__linkText--current">{{ prefecture }}で{{ peopleCount }}人以上の予算{{ yenCount }}円以下の宴会・パーティが可能なお店をご紹介</span>
          </li>
        </template>
        <template v-else-if="(pageType || shopType)">
          <li class="breadcrumbs__linkItem">
            <a href="..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ prefecture }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <span class="breadcrumbs__linkText breadcrumbs__linkText--current">{{ prefecture }}x{{ typeLabel }}</span>
          </li>
        </template>
        <template v-else-if="yenOrPeople && count">
          <li class="breadcrumbs__linkItem">
            <a href="..">
              <span class="breadcrumbs__linkText breadcrumbs__linkText">{{ prefecture }}</span>
            </a>
          </li>
          <li class="breadcrumbs__linkItem">
            <span class="breadcrumbs__linkText breadcrumbs__linkText--current">{{ prefecture }}で{{ yenOrPeopleLabel }}の宴会・パーティが可能なお店をご紹介</span>
          </li>
        </template>
        <template v-else>
          <li class="breadcrumbs__linkItem">
            <span class="breadcrumbs__linkText breadcrumbs__linkText--current">{{ prefecture }}</span>
          </li>
        </template>
      </template>
    </ul>
  </div>
</div>
